import { themeAssetUrl } from './themeAssets';

export default () => {
  let xhr;

  const initHeadroom = () => {
    let headroom = new Headroom($('.header').get(0), {
      tolerance: {
        down: 10,
        up: 10,
      },
      onUnpin: function () {
        if ($('html, body').hasClass('off-canvas-opened')) {
          $(this.elem).removeClass(this.classes.unpinned).addClass(this.classes.pinned);
        } else {
          $(this.elem).removeClass(this.classes.pinned).addClass(this.classes.unpinned);
        }
        if ($('.apn-header .apn-header-search input:focus').length > 0) {
          $(this.elem).removeClass(this.classes.unpinned).addClass(this.classes.pinned);
        }
      },
    });
    headroom.init();
  };

  const loadHeadroom = () => {
    if (typeof xhr === 'undefined' && window.matchMedia('screen and (max-width: 991px)').matches) {
      xhr = $.cachedScript(themeAssetUrl('js', 'headroom.js')).done(() => {
        initHeadroom();
      });
      $(window).off('resize', loadHeadroom);
    }
  };

  $(document).ready(() => {
    loadHeadroom();
  });
  $(window).resize(loadHeadroom);
};
